// Import the apps styles
import "../scss/app.scss";

// Import our modules
import "../node_modules/slick-carousel/slick/slick.min.js";
import "./modules/selectric/public/jquery.selectric.min.js"; // module npm does'tn work
import "../node_modules/jquery-mousewheel/jquery.mousewheel"; // necessaire pour mCustomScrollbar
import "../node_modules/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar";
import "./modules/simplelightbox/dist/simple-lightbox.js";
// import './modules/parallax.js-2.0.0-alpha/dist/jquery.parallax.min.js';

import MatchHeight from "@tannerhodges/match-height";
import { gsap, Expo, Back } from "gsap";
import SimpleLightbox from "simplelightbox";

import Ukiyo from "ukiyojs";

import AOS from "aos";
import $ from "jquery";
// require('malihu-custom-scrollbar-plugin')($);

window.addEventListener("DOMContentLoaded", () => {
	new SimpleLightbox(".gallery a");
	new SimpleLightbox(".wp-block-gallery a");
	new SimpleLightbox(".lightbox_header a");

	const images = document.querySelectorAll(".ukiyo");
	new Ukiyo(images, {
		speed: 1.4,
		scale: 1.15,
	});

	const seeMoreLocalisation = document.querySelectorAll(
		".see-details-localisation"
	);
	let i;

	for (i = 0; i < seeMoreLocalisation.length; ++i) {
		seeMoreLocalisation[i].addEventListener("click", (e) => {
			e.preventDefault();
			const target = e.target.getAttribute("data-target");
			if (e.target.classList.contains("open")) {
				e.target.classList.remove("open");
				document.getElementById(target).classList.remove("open");
			} else {
				e.target.classList.add("open");
				document.getElementById(target).classList.add("open");
			}
			console.log(target);
		});
	}
});

// Foundation init
$(function () {
	// -----------------------------  DRAW LINE HEADER

	// if ($('.home .burger_container').length > 0 || $('.page-template-default .burger_container').length > 0 || $('.error404 .burger_container').length > 0) {

	const drawLine = () => {
		const line = $(".line");
		if (line.length > 0) {
			const windowWidth = $(window).width();
			const logo = $(".custom-logo-link img");
			let widthLogo = 0;
			let positionLeftlogo = 0;

			if (logo.length > 0) {
				widthLogo = logo.innerWidth();
				positionLeftlogo = logo.position().left;
			}

			const burgerContainer = $(".burger_container");
			let widthBurger = 0;
			if (burgerContainer.length > 0) {
				widthBurger = burgerContainer.innerWidth();
			}
			const positionRightBurger =
				windowWidth -
				($(".burger_container").position().left + widthBurger);
			const lineWidth =
				windowWidth -
				(widthLogo + positionLeftlogo) -
				(widthBurger + positionRightBurger);

			logo.animate(
				{
					opacity: 1,
				},
				1000,
				function () {
					$(".line").css({
						left: widthLogo + positionLeftlogo + "px",
					});

					$(".line").animate(
						{
							width: lineWidth + "px",
						},
						1000,
						function () {
							// Animation complete.
							$(".burger_container").animate(
								{
									opacity: 1,
								},
								500,
								function () {
									// Animation complete.
									$(".burger").addClass("animated-bar");
								}
							);
						}
					);
				}
			);
		}
	};

	removeLoader();

	// si il n'y a pas de loader, alors on fait directement l'anim
	if ($("#loadingDiv").length === 0) {
		drawLine();
	}

	const resizeLine = () => {
		const line = $(".line");
		if (line.length > 0) {
			const windowWidth = $(window).width();
			const logo = $(".custom-logo-link img");
			let widthLogo = 0;
			let positionLeftlogo = 0;

			if (logo.length > 0) {
				widthLogo = logo.innerWidth();
				positionLeftlogo = logo.position().left;
			}

			const burgerContainer = $(".burger_container");
			let widthBurger = 0;
			if (burgerContainer.length > 0) {
				widthBurger = burgerContainer.innerWidth();
			}
			const positionRightBurger =
				windowWidth -
				($(".burger_container").position().left + widthBurger);
			const lineWidth =
				windowWidth -
				(widthLogo +
					positionLeftlogo +
					(widthBurger + positionRightBurger));

			line.css({
				width: lineWidth + "px",
			});
		}
	};

	function removeLoader() {
		var loader = $("#loadingDiv");
		if (loader.length !== 0) {
			$(".loader_container").animate(
				{
					opacity: 0,
				},
				2000,
				function () {
					// fadeOut complete.
					loader.animate(
						{
							height: 0,
						},
						1000,
						function () {
							// fadeOut complete. Remove the loading div
							if ($(".home .burger_container").length > 0) {
								drawLine();
							}
							AOS.init();
							displayFlyers();
							loader.remove(); //makes page more lightweight
						}
					);
				}
			);
		} else {
			AOS.init();
			displayFlyers();
		}
	}

	//---------------------------//
	// TARTE AU CITRON - COOKIES
	//---------------------------//
	// window.tarteaucitron.init({
	// 	privacyUrl: "" /* Privacy policy url */,
	// 	hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
	// 	cookieName: "tarteaucitron" /* Cookie name */,
	// 	orientation: "middle" /* Banner position (top - bottom - middle - popup) */,
	// 	groupServices: false /* Group services by category */,
	// 	showAlertSmall: false /* Show the small banner on bottom right */,
	// 	cookieslist: true /* Show the cookie list */,
	// 	showIcon: false /* Show cookie icon to manage cookies */,
	// 	// "iconSrc": "", /* Optionnal: URL or base64 encoded image */
	// 	iconPosition:
	// 		"BottomRight" /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */,
	// 	adblocker: false /* Show a Warning if an adblocker is detected */,
	// 	DenyAllCta: true /* Show the deny all button */,
	// 	AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
	// 	highPrivacy: true /* HIGHLY RECOMMANDED Disable auto consent */,
	// 	handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,
	// 	removeCredit: true /* Remove credit link */,
	// 	moreInfoLink: true /* Show more info link */,
	// 	useExternalCss: true /* If false, the tarteaucitron.css file will be loaded */,
	// 	//"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */
	// 	readmoreLink:
	// 		"" /* Change the default readmore link pointing to tarteaucitron.io */,
	// 	mandatory: true /* Show a message about mandatory cookies */,
	// });

	// window.tarteaucitron.user.googletagmanagerId = "GTM-MPFD4HK";
	// (window.tarteaucitron.job = window.tarteaucitron.job || []).push(
	// 	"googletagmanager"
	// );
	// (window.tarteaucitron.job = window.tarteaucitron.job || []).push(
	// 	"googlemapsembed"
	// );

	// (window.tarteaucitron.job = window.tarteaucitron.job || []).push("youtube");
	// (window.tarteaucitron.job = window.tarteaucitron.job || []).push("vimeo");

	// ----------------------------- sticky header
	function heightHeader() {
		var navHeight = $("#my-sticky-element").innerHeight();
		$("#my-sticky-element, #my-sticky-element .container-fluid").css(
			"height",
			navHeight
		);
	}
	heightHeader();

	//----------------------------- custom select
	$("select").selectric();

	//----------------------------- WORDS on hover on home

	function wordHover() {
		const windowWidth = $(window).width();
		var wordContent = $(".word_content");
		if (wordContent.length > 0) {
			$(".words_title .word").mouseenter(function () {
				var elementSelected = $(this).data("number-word");
				$(
					'.words_hover .word_content[data-number-word="' +
						elementSelected +
						'"]'
				).addClass("show");
				var position = $(".container_brand img").position();

				if (windowWidth > 768) {
					$(".container_brand .words_hover").css({
						top: position.top,
						left: position.left,
					});
				} else {
					$(".container_brand .words_hover").css({
						top: position.top,
						left: "",
					});
				}
			});

			$(".words_title .word").mouseleave(function () {
				var elementSelected = $(this).data("number-word");
				$(
					'.words_hover .word_content[data-number-word="' +
						elementSelected +
						'"]'
				).removeClass("show");
			});
		}
	}

	wordHover();

	//----------------------------- on window resize
	$(window).resize(function () {
		wordHover();

		resizeLine();

		fullHeight();

		// if ($('.applyHeight').length > 0) {
		//     $('.applyHeight').aplyHeight();
		// }

		customScroll();
		popupHeight();
		$(".js-customScroll").mCustomScrollbar("update");
	});

	//END WORDS HOVER

	//----------------------------- animation on hover image team, show a second image

	if ($(".team").length > 0) {
		var item = $(".team").find(".face_2");

		setInterval(function () {
			//after 1.5s
			item.animate(
				{
					// we remove animation
					opacity: 1,
				},
				2000,
				function () {
					// Animation complete.
					item.animate({
						opacity: 0,
					});
				}
			);
		}, 8000);
	}

	// -----------------------------  animation menu

	if ($(".header .burger_container").length > 0) {
		var elementClick = $(".header .burger_container");
		var menu = $(".overlay-menu");
		var tl = gsap.timeline({ paused: true });

		tl.to(".overlay-menu", 0.3, { opacity: 1, ease: Expo.easeOut }, 0)
			.to(
				".nav-primary",
				0.4,
				{ css: { transform: "translateY(0)" }, ease: Expo.easeOut },
				0
			)
			.to(menu, 0.4, { opacity: 1, ease: Back.easeIn }, 0.4)
			.staggerTo(menu.find("li"), 0.4, { scale: 1, ease: Expo.easeOut }, 0.1);

		elementClick.click(function (e) {
			e.preventDefault();
			if (menu.hasClass("open")) {
				menu.removeClass("open");
				elementClick.removeClass("active-burger");
				tl.reverse();
			} else if (!menu.hasClass("open")) {
				menu.addClass("open");
				elementClick.addClass("active-burger");
				tl.play();
			}
		});

		$(".overlay-menu").click(function (e) {
			if ($(e.target).hasClass("overlay-menu")) {
				if (menu.hasClass("open")) {
					menu.removeClass("open");
					elementClick.removeClass("active-burger");
					tl.reverse();
				}
			}
		});
	}

	//-----------------------------  burger menu blog
	var burgerBlog = $(".header-blog .burger");
	if (burgerBlog.length !== 0) {
		var menuBlog = $(".header-blog .menu_blog");
		burgerBlog.click(function (e) {
			e.preventDefault();
			menuBlog.slideToggle(1000);
		});
	}

	var offsetSize = $("#my-sticky-element").innerHeight();
	$(".js-scrollTo a").on("click", function (e) {
		// Au clic sur un élément
		var target = this.hash;
		var $target = $(target);
		var targetname = target.slice(1, target.length);

		if (document.getElementById(targetname) != null) {
			//if element is present in page
			e.preventDefault();
			$("html, body")
				.stop()
				.animate(
					{
						scrollTop: $target.offset().top - offsetSize, //or the height of your fixed navigation
					},
					900
				);
		} else {
			//if not present in page
			location.replace($(this).attr("href"));
		}
	});

	//-----------------------------  open popup
	$(".js-popUp a").on("click", function (e) {
		// Au clic sur un élément
		var target = this.hash;
		var $target = $(target);
		var targetname = target.slice(1, target.length);

		if (document.getElementById(targetname) != null) {
			//if element is present in page
			e.preventDefault();
			$($target)
				.animate(
					{
						opacity: 1,
					},
					1000
				)
				.addClass("open"); // Go
			$("body").css("overflow", "hidden");
		} else {
			//if not present in page
			location.replace($(this).attr("href"));
		}
	});

	$(".close_popup").on("click", function (e) {
		e.preventDefault();

		$("body").removeAttr("style");

		var popup = $(this).parent().attr("id");
		$("#" + popup)
			.animate(
				{
					opacity: 0,
				},
				1000
			)
			.removeClass("open");
	});

	//if there is a # in url
	let targetname = window.location.hash;
	if (targetname.length > 0) {
		if ($(targetname).length > 0) {
			//if element is present in page
			$(targetname)
				.animate(
					{
						opacity: 1,
					},
					1000
				)
				.addClass("open"); // Go
		}
	}

	// -----------------------------  CUSTOM SCROLL BAR
	function customScroll() {
		const windowWidth = $(window).width();

		// let popupHeight = $('.popup_content .content_container').innerHeight();
		const popupTitleHeight = $(".popup_content .title").outerHeight(true);

		//scroll bar on tag

		if (windowWidth > 991) {
			$(".popup_content .content_container .content_scroll").height(
				100 - (popupTitleHeight / $(window).height()) * 100 + "%"
			);

			$(".js-customScroll").mCustomScrollbar({
				contentTouchScroll: 10,
				documentTouchScroll: false,
				mouseWheel: { axis: "y", preventDefault: true },
			});
		} else {
			$(".js-customScroll").mCustomScrollbar("disable", true);
		}
	}

	// -----------------------------  full Height function
	function fullHeight() {
		var windowHeight = $(window).height();
		var navHeight = $("#my-sticky-element").innerHeight();

		if (windowHeight <= 500) {
			$(".full_height").css("height", "500px");
		} else {
			$(".full_height").css("height", windowHeight - navHeight);
		}
	}
	fullHeight(); //also in resize

	// END loader

	customScroll();

	$(window).on("DOMContentLoaded", function () {
		customScroll();
	});

	// for parallax
	// $.fn.aplyHeight = function () { // aplly height 1.5 taller than window height
	//     // Some code
	//     // var elementHeight = this.data("natural-height");
	//     // var windowHeight = $(window).height();
	//     // var elementHeightQuotien = elementHeight / (windowHeight * 1.5);
	//     // elementHeight = elementHeight / elementHeightQuotien;
	//     // this.css('height', elementHeight);

	//     let elementHeight = this.data("natural-height");
	//     const dataDepth = this.data("speed");
	//     const windowHeight = $(window).height();
	//     const elementHeightQuotien = elementHeight / (windowHeight * (dataDepth + 1));
	//     elementHeight = elementHeight / elementHeightQuotien;
	//     this.css('height', elementHeight);
	// };

	// if ($('.applyHeight').length > 0) {
	//     console.log( 'applyHeight');
	//     $('.applyHeight').aplyHeight();
	// }

	// window.Parallax.DEFAULTS.overScrollFix = true;

	// END -------

	const carouselHeader = $(".slick-slider-header");
	if (carouselHeader.length > 0) {
		carouselHeader.slick({
			slidesToShow: 1,
			arrows: false,
			dots: true,
			infinite: false,
			autoplay: true,
			autoplaySpeed: 3000,
			pauseOnHover: true,
			pauseOnDotsHover: true,
		});
	}

	//-------------------------------- pop up flyers

	function popupHeight() {
		if ($(".popUpFlyers").length === 1) {
			var popup = $(".popUpFlyers");
			var windowHeight = $(window).height();
			var popupContainer = $(".popUpFlyers-content-container");
			var popupContent = $(".popUpFlyers-content");
			var popupHeightContent = popupContainer.height();
			var popupHeight = popupContent.height();

			if (popup.hasClass("contain_link") === true) {
				popupHeightContent = popupHeightContent + 88;
			}

			let btnHeight = 0;
			if (popup.hasClass("contain_link") === true) {
				btnHeight = 88;
			}

			if (popup.hasClass("contain_img") === true) {
				let contentPaddingPopup = $(".popUpFlyers-content").css("padding");
				contentPaddingPopup = contentPaddingPopup.replace("px", "");
				contentPaddingPopup = parseInt(contentPaddingPopup);
				$(".popUpFlyers-content").css("max-height", windowHeight);

				$(".popUpFlyers-content-container img").css(
					"max-height",
					windowHeight * 0.9 - contentPaddingPopup * 2 - btnHeight
				);
			} else {
				if (popupHeightContent < popupHeight) {
					popupContent.css("height", "auto");
				} else {
					//if the content is bigger that the poppup

					//console.log( popupHeight + ' > ' + windowHeight);
					popupContent.css("height", windowHeight * 0.9 - btnHeight);
					$(".popUpFlyers-customScroll").mCustomScrollbar();
				}
			}
		}
	}

	// display popup
	function popupflyers() {
		const lang = document.documentElement.lang;
		if ($(".popUpFlyers").length === 1) {
			popupHeight();

			setTimeout(function () {
				$(".popUpFlyers").addClass("open");
				$("body").append("<div class='overlay'></div>");
				$("body").addClass("popupOverlay");

				$(".overlay").animate(
					{
						opacity: 1,
					},
					1000,
					function () {}
				);
			}, 3000);

			$(".popUpFlyers .close_popup").click(function () {
				$(".popUpFlyers").removeClass("open");
				$("body").css("overflow", "scroll");

				$(".overlay").animate(
					{
						opacity: 0,
					},
					1000,
					function () {
						$("body").removeClass("popupOverlay");
						$("body").remove(".overlay");
					}
				);
			});
			sessionStorage.setItem(`popin-${lang}`, "true");
		} else {
			sessionStorage.setItem(`popin-${lang}`, "false");
		}
	}

	function displayFlyers() {
		const lang = document.documentElement.lang;
		if (typeof sessionStorage != "undefined") {
			if (`popin-${lang}` in sessionStorage) {
				// if key popin in sesssion storage exist
				var popin = sessionStorage.getItem(`popin-${lang}`);
				if (popin === "true") {
					console.log("popup already displayed");
				}
			} else {
				// if key popin in sesssion storage does't existe we set the value to false
				popupflyers();
			}
		} else {
			console.log("sessionStorage n'est pas supporté");
		}
	}
});
